<template>
  <validation-observer ref="AddForm" #default="{ invalid }">
    <b-form @submit.prevent="formSubmitted">
      <b-row>
        <b-col md="12">
          <b-form-group label="Project Name" label-for="project-name">
            <validation-provider
              #default="{ errors }"
              name="Project Name"
              vid="Project Name"
              rules="required"
            >
              <b-form-input
                id="project-name"
                placeholder="No Name"
                required
                v-model="project.name"
                :disabled="actionType === 'view'"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group label="Description" label-for="description">
            <validation-provider
              #default="{ errors }"
              name="Description"
              vid="Description"
              rules="required"
            >
              <b-form-textarea
                id="description"
                placeholder="Description of project "
                rows="3"
                required
                :disabled="actionType === 'view'"
                v-model="project.description"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group label="Customer" label-for="customer">
            <b-spinner
              v-if="loadingCustomer"
              variant="primary"
              class="mx-2"
            ></b-spinner>
            <b-form-select
              v-model="project.customerId"
              :options="optionsCustomer"
              v-if="!loadingCustomer"
              :disabled="actionType === 'view'"
            >
            </b-form-select>
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group label="Assignee" label-for="assignee">
            <validation-provider
              #default="{ errors }"
              name="Assignee"
              vid="Assignee"
              rules="required"
            >
              <v-select
                id="assignee"
                v-model="project.assigneeId"
                dir="ltr"
                multiple
                label="text"
                :options="assignee"
                :reduce="(option) => option.value"
                :disabled="actionType === 'view'"
              />

              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group label="Approver" label-for="approver">
            <validation-provider
              #default="{ errors }"
              name="Approver"
              vid="Approver"
              rules="required"
            >
              <b-form-select
                id="approver"
                v-model="project.approverId"
                :options="assignee"
                :disabled="actionType === 'view'"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group label="Supervisor" label-for="supervisor">
            <v-select
              id="supervisor"
              v-model="project.supervisorId"
              dir="ltr"
              multiple
              label="text"
              :options="assignee"
              :reduce="(option) => option.value"
              :disabled="actionType === 'view'"
            />
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group label="Project Status" label-for="project-status">
            <b-form-select
              v-model="project.status"
              :options="statusOptions"
              :disabled="actionType === 'view'"
            >
            </b-form-select>
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group label="Progress" label-for="Progress">
            <b-form-select
              v-model="project.progress"
              :options="progressOptions"
              id="Progress"
              :disabled="actionType === 'view'"
            >
            </b-form-select>
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group label="Priority" label-for="Priority">
            <b-form-select
              v-model="project.priority"
              :options="priorityOptions"
              id="priority"
              :disabled="actionType === 'view'"
            >
            </b-form-select>
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group label="Budget" label-for="budget">
            <b-form-input
              id="budget"
              v-model="project.budget"
              type="number"
              :disabled="actionType === 'view'"
            />
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group label="Expense" label-for="expense">
            <b-form-input
              id="expense"
              v-model="project.expense"
              type="number"
              :disabled="actionType === 'view'"
            />
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group label="Estimates" label-for="estimates">
            <b-form-input
              id="estimates"
              v-model="project.estimates"
              type="number"
              :disabled="actionType === 'view'"
            />
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group label="Start Date" label-for="Start-Date">
            <b-form-datepicker class="mb-1" v-model="project.startDate" />
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group label="End Date" label-for="End-Date">
            <b-form-datepicker class="mb-1" v-model="project.endDate" />
          </b-form-group>
        </b-col>

        <b-col
          md="12"
          class="d-flex justify-content-between"
          v-if="actionType === 'edit'"
        >
          <b-button type="button" @click="formSubmitted()" variant="primary"
            >Save</b-button
          >
        </b-col>
      </b-row>
    </b-form>
  </validation-observer>
</template>

<script>
import vSelect from "vue-select";
import {
  BRow,
  BCol,
  BForm,
  BFormInput,
  BFormTextarea,
  BFormSelect,
  BFormDatepicker,
  BFormGroup,
  BButton,
  BSpinner,
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import "@/libs/customValidation";
import {
  ProjectStatus,
  ProjectProgress,
  ProjectPriority,
  TaskStatus,
} from "@/libs/defaultList";
import {
  fnSortingDropdown,
  customLoader,
  customError,
  customSwal,
} from "@/libs/customFn";

export default {
  name: "AddProject",
  components: {
    vSelect,
    BRow,
    BCol,
    BForm,
    BFormInput,
    BFormTextarea,
    BFormSelect,
    BFormDatepicker,
    BFormGroup,
    BButton,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
  },

  props: {
    project: {
      type: Object,
      default: () => ({}),
    },
    assignee: {
      type: Array,
      default: () => [],
    },
    actionType: {
      type: String,
      default: () => "edit",
    },
  },

  data() {
    return {
      assetCode: "",
      purchaseDate: null,
      optionsCustomer: [],
      lifeEndDate: null,
      maintainanceDate: null,
      location: "",
      selected: 1,
      assignee_options: [],
      costPerHour: 0,
      projectManagerOptions: [
        { value: "Staff1", text: "Staff 1" },
        { value: "Staff2", text: "Staff 2" },
        { value: "Staff3", text: "Staff 3" },
      ],
      progressOptions: ProjectProgress,
      priorityOptions: ProjectPriority,
      statusOptions: ProjectStatus,
    };
  },

  methods: {
    ...mapActions("customerModule", ["getCustomersListAction"]),
    ...mapActions("projectModule", [
      "updateProjectAction",
      "getProjectAssigneesAction",
    ]),

    async formSubmitted() {
      let isValid = await this.$refs.AddForm.validate();
      if (isValid) {
        console.log("project1: ", this.project);
        if (this.project.startDate && this.project.endDate) {
          if (
            new Date(this.project.startDate) > new Date(this.project.endDate)
          ) {
            customError("End Date cannot be before Start Date.");
            return;
          } else if (
            new Date(this.project.endDate) < new Date(this.project.startDate)
          ) {
            customError("Start Date cannot be after End Date.");
            return;
          }
        }

        let loader = customLoader(
          "Please wait while the project is being added"
        );

        this.project.approverName = this.assignee.filter(
          (x) => x.value === this.project.approverId
        )[0].text;
        let payload = {
          ...this.project,
        };

        const selectedCustomer = this.optionsCustomer.find(
          (customer) => customer.value === this.project.customerId
        );

        if (selectedCustomer) {
          payload.customerName = selectedCustomer.text;
        }
        this.updateProjectAction(payload)
          .then(() => {
            loader.close();
            customSwal("You have successfully updated the project!");
            this.$emit("projectAdded");
           
          })
          .catch((ex) => {
            loader.close();
            customError(ex.response.data);
            this.$emit("projectAdded");
          });
      }
    },
  },
  computed: {
    ...mapGetters("customerModule", {
      CustomerList: "customers",
      loadingCustomer: "loading",
    }),

    assigneeName() {
      const assignee = this.assignee.find(
        (option) => option.value === this.project.assigneeId
      );
      return assignee ? assignee.text : "";
    },
  },

  async mounted() {
    try {
      await this.getCustomersListAction();
      this.optionsCustomer = this.CustomerList.map((customer) => ({
        value: customer.id,
        text: `${customer.otherName} ${customer.surname ?? ''}`,
      }));
    } catch (error) {
      console.error(error);
    }
  },
};
</script>


<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>